var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',[(_vm.model !== null)?_c('Calculator',{staticClass:"mb-4 ml-4 mr-4",attrs:{"model":_vm.model}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }